export const Constants = {
    PAGE: {
        TITLE: 'Privacy & Data Opt-Out',
    },
    API_NAME: 'privacyoptoutapi',
    API_PATH: '/privacy',
    REQUEST_TYPES: [
        { label: 'Access My Information', value: 'ACCESS' },
        { label: 'Delete My Information', value: 'DELETE' },
        { label: 'Opt-out', value: 'OPT_OUT' },
    ],
    CONTACT_EMAIL: 'privacy@sportsilab.com',
    PRIVACY_POLICY_URL: 'https://www.sportsilab.com/privacy-policy',
};
